/**
 * Sets up a sort function for sorting objects based on multiple properties
 * 
 * @note the order the props are sent in is the order in which they will be sorted
 * 
 * @param {Array} propsarray The array of props to sort on
 * @param {Object<string, array>} idColMapper A map of id columns. If this is passed in, any column that has been mapped will sort based on the object provided.
 * @returns a sorting function, set up to sort on multiple properties
 */
const dynamicSortMultiple = (propsarray, idColMapper = {}) => {
    //https://stackoverflow.com/questions/1129216/sort-array-of-objects-by-string-property-value
    /*
    * save the arguments object as it will be overwritten
    * note that arguments object is an array-like object
    * consisting of the names of the properties to sort by
    */
    var props = arguments; //argggg - Etienne added propsarray instead
    props = propsarray
   
   // props = ['pickStr2','pickStr1']
   // console.log('pprops2', props, arguments)
    return function (obj1, obj2) {
        var i = 0, result = 0, numberOfProperties = props.length;
        /* try getting a different result from 0 (equal)
        * as long as we have extra properties to compare
        */
        while(result === 0 && i < numberOfProperties) {
            
            result = dynamicSort(props[i], idColMapper)(obj1, obj2);
            i++;
        }
        return result;
    }
}

/**
 * Sets up a sort function for sorting objects based on one property
 * 
 * @param {string} property The property to sort on
 * @param {Object<string, array>} idColMapper A map of id columns. If this is passed in, any column that has been mapped will sort based on the object provided.
 * @returns a sorting function, set up to sort on one property
 */
const dynamicSort = (property, idColMapper = {}) => {
    //console.log('sort by ', property)
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    //if the property includes ||, then go down by one level
    let propDownLevel = property.includes("||")

    return function (a,b) {
        /* next line works with strings and numbers, 
        * and you may want to customize it to your needs
        */
       var result
       if (!propDownLevel) {
            //if the property is in the idColMapper, then use the value from that instead of the values
            //this only applies here, as the other has multiple values.
            //this might change, if the other scenario needs to use the idColMapper
            const firstValue = Object.keys(idColMapper).includes(property) ? idColMapper[property][a[property]] : a[property]
            const seconValue = Object.keys(idColMapper).includes(property) ? idColMapper[property][b[property]] : b[property]

            result = (firstValue < seconValue) ? -1 : (firstValue > seconValue) ? 1 : 0;
        } else {
            // 0 will be top level, 1 will be level below
            const properties = property.split('||')
            result = (a[properties[0]][properties[1]] < b[properties[0]][properties[1]])
                ? -1
                : (a[properties[0]][properties[1]] > b[properties[0]][properties[1]])
                    ? 1
                    : 0
        }
        return result * sortOrder;
    }
}

const sortEntries = (property) => {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }              
}

const isNumeric = (string) => {
    return !isNaN(parseFloat(string)) && isFinite(string)
}

const validateDates = (startDate, endDate) => {
    let ans = true
    console.log(startDate, endDate, "%%%")
    if (startDate != null && startDate != '') {
        ans = ans && !isNaN(Date.parse(startDate))
    }
    if (endDate != null && endDate != '') {
        ans = ans && !isNaN(Date.parse(endDate))
    }

    if (endDate != null && startDate != null && endDate != '' && startDate != '') {
        // Checks for start date before end date
        ans = ans && Date.parse(startDate) <= Date.parse(endDate)
    }
    
    return ans
}

const getBaseLog = (value, base) => {
    return Math.log(value) / Math.log(base)
}

// This is mostly used for naming files
const getTimestamp = () => {
    const now = new Date();
    const dateStr = now.toISOString().split('T')[0].replace(/-/g, '');
    const timeStr = now.toTimeString().split(' ')[0].replace(/:/g, '');
    return `${dateStr}_${timeStr}`;
}

/**
 * Specifies the directions in which a column can be sorted
 *  
 * @enum {Number}
 */
const sortDirections = Object.freeze({
    NONE: 0,
    ASCENDING: 1,
    DESCENDING: 2
})

const showAlert = (text) => {
    alert(text)
}

export {dynamicSort, dynamicSortMultiple, sortEntries, isNumeric, validateDates, getBaseLog, sortDirections, showAlert, getTimestamp}
